export const companyInfo = {
  name: 'Metta People Ltd (Thailand)',
  version: '1.0',
  effectiveDate: 'July 21, 2026',
};

// Block types used below:
// p          -> paragraph
// ul         -> bullet list
// subheading -> small bold lead-in heading before a list, { id }
// table      -> multi-column table with header row (headerIds + rows)
// callout    -> bordered sub-section box (titleId + bodyId)
// contact    -> contact cards, { cards: [{ headingId, rows: [{ labelId?, value }] }] }

export const cookieSections = [
  {
    number: '1',
    titleId: 'CookiePolicyPage.s1.title',
    accentBar: true,
    blocks: [
      { type: 'p', id: 'CookiePolicyPage.s1.b1' },
      { type: 'p', id: 'CookiePolicyPage.s1.b2' },
      { type: 'p', id: 'CookiePolicyPage.s1.b3' },
    ],
  },

  {
    number: '2',
    titleId: 'CookiePolicyPage.s2.title',
    gradient: true,
    blocks: [
      { type: 'p', id: 'CookiePolicyPage.s2.b1' },
      { type: 'p', id: 'CookiePolicyPage.s2.b2' },
      { type: 'subheading', id: 'CookiePolicyPage.s2.sub1.title' },
      {
        type: 'ul',
        itemIds: ['CookiePolicyPage.s2.sub1.li1', 'CookiePolicyPage.s2.sub1.li2'],
      },
      { type: 'subheading', id: 'CookiePolicyPage.s2.sub2.title' },
      {
        type: 'ul',
        itemIds: ['CookiePolicyPage.s2.sub2.li1', 'CookiePolicyPage.s2.sub2.li2'],
      },
    ],
  },

  {
    number: '3',
    titleId: 'CookiePolicyPage.s3.title',
    blocks: [
      {
        type: 'table',
        headerIds: [
          'CookiePolicyPage.table.category',
          'CookiePolicyPage.table.purpose',
          'CookiePolicyPage.table.canDisable',
        ],
        rows: [
          [
            'CookiePolicyPage.s3.r1.category',
            'CookiePolicyPage.s3.r1.purpose',
            'CookiePolicyPage.s3.r1.canDisable',
          ],
          [
            'CookiePolicyPage.s3.r2.category',
            'CookiePolicyPage.s3.r2.purpose',
            'CookiePolicyPage.s3.r2.canDisable',
          ],
          [
            'CookiePolicyPage.s3.r3.category',
            'CookiePolicyPage.s3.r3.purpose',
            'CookiePolicyPage.s3.r3.canDisable',
          ],
          [
            'CookiePolicyPage.s3.r4.category',
            'CookiePolicyPage.s3.r4.purpose',
            'CookiePolicyPage.s3.r4.canDisable',
          ],
        ],
      },
    ],
  },

  {
    number: '4',
    titleId: 'CookiePolicyPage.s4.title',
    gradient: true,
    blocks: [
      { type: 'p', id: 'CookiePolicyPage.s4.intro' },
      {
        type: 'table',
        headerIds: [
          'CookiePolicyPage.table.cookieName',
          'CookiePolicyPage.table.provider',
          'CookiePolicyPage.table.purpose',
          'CookiePolicyPage.table.duration',
        ],
        rows: [
          [
            'CookiePolicyPage.s4.r1.name',
            'CookiePolicyPage.s4.r1.provider',
            'CookiePolicyPage.s4.r1.purpose',
            'CookiePolicyPage.s4.r1.duration',
          ],
          [
            'CookiePolicyPage.s4.r2.name',
            'CookiePolicyPage.s4.r2.provider',
            'CookiePolicyPage.s4.r2.purpose',
            'CookiePolicyPage.s4.r2.duration',
          ],
          [
            'CookiePolicyPage.s4.r3.name',
            'CookiePolicyPage.s4.r3.provider',
            'CookiePolicyPage.s4.r3.purpose',
            'CookiePolicyPage.s4.r3.duration',
          ],
          [
            'CookiePolicyPage.s4.r4.name',
            'CookiePolicyPage.s4.r4.provider',
            'CookiePolicyPage.s4.r4.purpose',
            'CookiePolicyPage.s4.r4.duration',
          ],
          [
            'CookiePolicyPage.s4.r5.name',
            'CookiePolicyPage.s4.r5.provider',
            'CookiePolicyPage.s4.r5.purpose',
            'CookiePolicyPage.s4.r5.duration',
          ],
        ],
      },
      { type: 'p', id: 'CookiePolicyPage.s4.outro' },
    ],
  },

  {
    number: '5',
    titleId: 'CookiePolicyPage.s5.title',
    blocks: [
      { type: 'p', id: 'CookiePolicyPage.s5.intro' },
      {
        type: 'ul',
        itemIds: [
          'CookiePolicyPage.s5.li1',
          'CookiePolicyPage.s5.li2',
          'CookiePolicyPage.s5.li3',
          'CookiePolicyPage.s5.li4',
        ],
      },
      { type: 'p', id: 'CookiePolicyPage.s5.outro' },
    ],
  },

  {
    number: '6',
    titleId: 'CookiePolicyPage.s6.title',
    gradient: true,
    blocks: [
      { type: 'p', id: 'CookiePolicyPage.s6.b1' },
      {
        type: 'callout',
        titleId: 'CookiePolicyPage.s6.callout.title',
        bodyId: 'CookiePolicyPage.s6.callout.body',
      },
      { type: 'p', id: 'CookiePolicyPage.s6.b2' },
    ],
  },

  {
    number: '7',
    titleId: 'CookiePolicyPage.s7.title',
    blocks: [
      { type: 'p', id: 'CookiePolicyPage.s7.intro' },
      {
        type: 'ul',
        itemIds: ['CookiePolicyPage.s7.li1', 'CookiePolicyPage.s7.li2', 'CookiePolicyPage.s7.li3'],
      },
      { type: 'p', id: 'CookiePolicyPage.s7.outro' },
    ],
  },

  {
    number: '8',
    titleId: 'CookiePolicyPage.s8.title',
    accentBar: true,
    blocks: [{ type: 'p', id: 'CookiePolicyPage.s8.b1' }],
  },

  {
    number: '9',
    titleId: 'CookiePolicyPage.s9.title',
    gradient: true,
    blocks: [{ type: 'p', id: 'CookiePolicyPage.s9.b1' }],
  },

  {
    number: '10',
    titleId: 'CookiePolicyPage.s10.title',
    accentBar: true,
    blocks: [{ type: 'p', id: 'CookiePolicyPage.s10.b1' }],
  },

  {
    number: '11',
    titleId: 'CookiePolicyPage.s11.title',
    blocks: [
      {
        type: 'contact',
        cards: [
          {
            headingId: 'CookiePolicyPage.s11.card1.heading',
            rows: [{ value: 'Metta People Ltd (Thailand)' }],
          },
          {
            headingId: 'CookiePolicyPage.s11.card2.heading',
            rows: [
              {
                value:
                  '41/1, Soi On Nut 36, On Nut Sub-district, Suan Luang District, Bangkok 10250, Thailand',
              },
            ],
          },
          {
            headingId: 'CookiePolicyPage.s11.card3.heading',
            rows: [{ value: 'info@mettapeople.com' }],
          },
          {
            headingId: 'CookiePolicyPage.s11.card4.heading',
            rows: [{ value: 'www.mettapeople.com' }],
          },
        ],
      },
    ],
  },
];
